/**
 * JezLista!
 * ======================================
 * - automaticky schová přetékající položky
 */

var $el = $('#jezlista')
var $elToggle = $('#jezlista .jezlista__navtoggle')

var init = function() {
	var wrapper = $el.find('.jezlista__list').outerWidth()
	var $items = $el.find('.jezlista__list').children()
	var $hiddenItems = $el.find('.jezlista__togglenav__item')

	$items.removeClass('is-hidden')
	$hiddenItems.addClass('is-hidden')

	$items.each(function(){
		var $this = $(this)
		var itemPos = $this.position().left
		var itemWidth = $this.outerWidth()
		var current = itemPos + itemWidth

		if(current > wrapper){
			$this.addClass('is-hidden')
			$hiddenItems.eq($this.index()).removeClass('is-hidden')
		}
	})

	var isHidden = $('.jezlista__item.is-hidden').length

	if(isHidden > 0){
		$elToggle.removeClass('is-hidden')
	}else{
		$elToggle.addClass('is-hidden')
	}


}

 $('.js-jezlistatoggle').on('click', function(e){
 	$('body').toggleClass('jezlista-is-open')
 	$.magnificPopup.close()

  e.preventDefault()
})

init()

window.onresize = init
